import React from "react";
import "./style.css";
import classNames from "classnames";
export default function RadioButtonOptions(props) {
    const { state, options, alignment = "horizontal", style = "low-pr", preIndex = "", disablePadding = false, } = props;
    return (React.createElement("div", { className: "radio-buttons-container " +
            classNames({
                "radio-buttons-container-horizaontal": alignment === "horizontal",
                "radio-buttons-container-vertical": alignment === "vertical",
                "radio-buttons-container-horizontal-full": alignment === "horizontal-full",
                "radio-buttons-container-no-padding": disablePadding,
            }) +
            (style === "low-pr" ?
                " radio-buttons-container-low-pr"
                : " radio-buttons-container-high-pr") },
        React.createElement("span", null, props.label),
        React.createElement("div", { className: "radio-buttons-box" }, options.map((option, index) => (React.createElement("label", { key: index, htmlFor: preIndex + option.value, className: "radio-button-container" +
                (state === option.value ? " radio-button-container-checked" : "") },
            React.createElement("input", { id: preIndex + option.value, checked: state === option.value, type: "radio", onChange: () => { var _a; return (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, option.value); } }),
            option.label))))));
}
